import { render, staticRenderFns } from "./ListeProduitsTable.vue?vue&type=template&id=1593754f"
import script from "./ListeProduitsTable.vue?vue&type=script&lang=js"
export * from "./ListeProduitsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports